
module.exports = function (paths, config) {
    const FURTHER_REF = paths.FURTHER_REF
    return {
      test: /\.(png|jp(e)?g|gif|webp|svg|ttf|woff|woff2)$/,
      use: [
        {
          loader: FURTHER_REF + 'file-loader',
          options: {
            name: 'assets/[name]-[hash].[ext]' //,
            // publicPath: 'public'
          }
        },
        {
          loader: FURTHER_REF + 'url-loader',
          options: {
            name: 'assets/[name]-[hash].[ext]',
            limit: 10000
          }
        }
      ]
    }
}


// WEBPACK FOOTER //
// ./src/technologies/images.js